import {
  isOnboardingAccountSetupComplete,
  getOnboardingStepFlags,
} from 'components/onboarding-account-setup/onboarding-account-setup.selectors';
import { usePatientPortalContext } from 'contexts/patient-portal-provider.context';
import { getLeagueSdkErrorCode } from 'utils/parse-league-sdk-error';
import { useGetUserProfile } from '../queries/use-get-user-profile.hook';

export const useOnboardingCompletion = () => {
  const { data, isLoading, error } = useGetUserProfile();
  const { systemId } = usePatientPortalContext();

  const errorCode = error ? getLeagueSdkErrorCode(error) : undefined;
  const isNewUser = errorCode === 404;

  const {
    shouldRenderTermsStep,
    shouldRenderMarketingStep,
    shouldRenderPhoneNumberStep,
  } = getOnboardingStepFlags(data, systemId);

  return {
    accountSetupComplete: isOnboardingAccountSetupComplete(data, systemId),
    featureHighlightsComplete: !shouldRenderTermsStep,
    isLoading,
    error: isNewUser ? null : error,
    // Content-derived signature of the rendered step set. Changes only
    // when a step flag actually flips (e.g. consent recorded), so it can
    // be used as a remount key for OnboardingAccountSetup to reset the
    // Stepper when the relevant profile data changes. Deliberately not
    // keyed on the fetch timestamp: that bumps on every refetch and, with
    // refetch-on-mount, would create an infinite remount/refetch loop.
    stepFlagsKey: `${Number(shouldRenderTermsStep)}${Number(
      shouldRenderMarketingStep,
    )}${Number(shouldRenderPhoneNumberStep)}`,
  };
};
